/*
*  Site content. Copy is word-for-word from the original Wix site (www.aboutu.co.za) - check with the client before rewording
*/

export const SITE_NAME = "AboutU";
export const SITE_URL = "https://www.aboutu.co.za";
export const DEFAULT_DESCRIPTION = "We are Discovery Financial Advisors, whose experience spans across all areas of financial planning to ensure comprehensive and tailored solutions for our clients' unique needs and goals.";

export const ROUTES = {
  HOME: "/",
  SERVICES: "/our-services",
  TEAM: "/aboutu-team",
  COMPANY_STATEMENT: "/company-statement",
  TESTIMONIALS: "/client-testimonials",
  BLOG: "/blog",
  POST: "/post", //Blog posts are at /post/<slug>, the same as on Wix, so existing links keep working
  CONTACT: "/contact-us",
};

export const CONTACT_DETAILS = {
  PHONES: [
    { label: "+27 86 164 3527", link: "tel:+27861643527" },
    { label: "+27 44 874 2762", link: "tel:+27448742762" },
    { label: "+27 44 011 0041", link: "tel:+27440110041" },
  ],
  EMAIL: "info@aboutu.co.za",
  WHATSAPP_LINK: "https://wa.me/27791418604",
  FACEBOOK_LINK: "https://www.facebook.com/share/19tSxrHdSV/",
  //From the business info on the Wix site - confirm with the client
  ADDRESS: "35 York Street, Dormehls Drift, George, 6529",
  MAP_EMBED: "https://maps.google.com/maps?q=35%20York%20Street%2C%20Dormehls%20Drift%2C%20George%2C%206529&z=16&output=embed",
  MAP_LINK: "https://www.google.com/maps/search/?api=1&query=35+York+Street%2C+Dormehls+Drift%2C+George%2C+6529",
};

export const LEGAL = {
  COMPANY: "about U Financial Advisors (Pty) Ltd | Registration number: 2013/142969/07. about U Financial Advisors is a mandated juristic representative of Discovery Life, an authorised Financial Services Provider, FSP License number 18147",
  POLICIES: [
    { label: "Privacy Policy", link: "/documents/privacy-policy.pdf" },
    { label: "Complaints Policy", link: "/documents/complaints-policy.pdf" },
    { label: "Conflict of Interest Policy", link: "/documents/conflict-of-interest-policy.pdf" },
    { label: "PAIA", link: "/documents/paia-manual.pdf" },
  ],
};

/* ------------------------------ SERVICES ------------------------------ */

//Order is as shown on the Our Services page
export const SERVICES = [
  {
    path: "/short-term-insurance",
    name: "Short Term Insurance",
    tile: "/images/services/tile-short-term-insurance.webp",
    tileAlt: "Couple meeting with an adviser",
    background: "/images/services/bg-short-term-insurance.webp",
    title: "Short Term Insurance:  Car & Home Insurance",
    intro: [
      "Discovery Insure offers the most innovative insurance together with an award winning reward programme: Vitality Drive. We do offer the best solution on various plan types for protection when you need it most.  When certain insured events occur such as vehicle accidents; car theft/hijacking; damage to private property or household items you want peace of mind that all needs were taken care of.  We will take you through all the value-add options that can benefit your needs. Do not miss the benefits of 24/7 assistance and the Impact Alert benefit.",
    ],
    listHeading: "We offer:",
    list: [
      "Comprehensive solutions through evaluation of personal and business needs, to ensure that the best possible cover is provided.",
      "Full support service, claims enquiries, option, and plan changes as well as monthly debit order reconciliations.",
      "Annual revision opportunities for the re-evaluation of your plan choice.",
      "Coaching on Vitality Drive to ensure maximum cash back.",
    ],
    images: [
      "/images/services/short-term-insurance-1.webp",
      "/images/services/short-term-insurance-2.webp",
      "/images/services/short-term-insurance-3.webp",
      "/images/services/short-term-insurance-4.webp",
    ],
  },
  {
    path: "/medical-schemes-gap-cover-1",
    menuName: "Medical schemes & Gap cover",
    name: "Medical Schemes",
    tile: "/images/services/tile-medical-schemes.webp",
    tileAlt: "Doctor examining a young boy",
    background: "/images/services/bg-medical-schemes.webp",
    title: "Medical schemes & Gap cover",
    intro: [],
    listHeading: "We offer:",
    list: [
      "Comprehensive medical aid solutions through evaluation of personal and business needs, to ensure that the best possible medical option/aid is chosen for the employer/employee as well as the individual/family.",
      "Full hospital authorisations service, claims enquiries, option and plan changes as well as monthly debit order reconciliations for the employer.",
      "Comprehensive national training to members to understand medical aids.",
      "Annual revision opportunities for the re-evaluation of your plan choice.",
      "GAP cover to insure you and your family against unexpected medical cost.  It covers shortfalls on approved in-hospital claims as well as cover for co-payments on MRI & CT-scans as well as cancer-related claims.",
    ],
    images: [
      "/images/services/medical-schemes-1.webp",
      "/images/services/medical-schemes-2.webp",
      "/images/services/medical-schemes-3.webp",
      "/images/services/medical-schemes-4.webp",
    ],
  },
  {
    path: "/investments-retirement",
    name: "Investments & Retirement",
    tile: "/images/services/tile-investments-retirement.webp",
    tileAlt: "Family relaxing together at home",
    background: "/images/services/bg-investments-retirement.webp",
    title: "Investments & Retirement Planning",
    intro: [
      "When you spend such a large portion of your life working it only makes sense to know that you’re working towards a secure and enjoyable retirement. We will assist you to help you make the best choices when it comes to well-informed and well-managed retirement planning.",
    ],
    listHeading: "We offer:",
    list: [
      "Endowments, Flexible investments & Tax free investments",
      "Various Offshore Investment options",
      "Fixed Annuities & Guaranteed plans",
    ],
    images: [
      "/images/services/investments-retirement-1.webp",
      "/images/services/investments-retirement-2.webp",
      "/images/services/investments-retirement-3.webp",
      "/images/services/investments-retirement-4.webp",
    ],
  },
  {
    path: "/risk-cover",
    menuName: "Risk cover",
    name: "Risk Cover",
    tile: "/images/services/tile-risk-cover.webp",
    tileAlt: "Father carrying his child on his shoulders",
    background: "/images/services/bg-risk-cover.webp",
    title: "Risk cover: Life, disability, severe illness cover & Income protection",
    intro: [
      "Life cover is a way of ensuring that your family or dependents are financially secure after your death. Things to consider when investing in life insurance is the amount of cover you need, how it will be paid out and if there are options of having readily available cash while your estate is being wound up. When it comes to life cover, it is important to understand the necessity, benefits, and advantages of different offerings. For example, if you are a single, young professional with no dependents, looking at products offering income protection, disability, trauma, and accident cover will make more sense than taking out a life insurance policy with just life cover. You will need the correct advice in selecting the right cover. Our specialist advisers will guide you to ensure that the right product is chosen to meet your specific requirements.",
    ],
    listHeading: "We offer solutions for:",
    list: [
      "Structured life cover.",
      "Income protection, disability cover, trauma cover and accident cover.",
      "Business insurance, key man insurance, buy and sell agreements, contingent liability and business operational cost protection for your business including the compulsory agreements applicable.",
      "Employee benefits, pension funds, provident funds, and preservation funds, with countrywide information and implementation sessions.",
    ],
    //The Wix page's image widget was broken, so these two photos stand in for it
    images: [
      "/images/services/risk-cover-1.webp",
      "/images/services/risk-cover-2.webp",
    ],
  },
  {
    path: "/banking",
    name: "Banking",
    tile: "/images/services/tile-banking.webp",
    tileAlt: "Clients shaking hands with an adviser",
    background: "/images/services/bg-banking.webp",
    title: "Banking",
    intro: [
      "Discovery Bank is designed to share the value that you create by managing your money well, back with unprecedented interest rates as well as retail and travel discounts and rewards.",
      "As mandated representatives of Discovery Life we do offer Specialist on all the Discovery Bank products to you to assist.  Do you know that you can get an account with zero monthly fees?",
      "You can open an account in a foreign currency and start transacting immediately.",
      "All options are available from savings accounts up to money market accounts and fixed deposits and Forex accounts.",
    ],
    list: [],
    images: [
      "/images/services/banking-1.webp",
      "/images/services/banking-2.webp",
      "/images/services/banking-3.webp",
      "/images/services/banking-4.webp",
    ],
  },
  {
    path: "/vitality",
    name: "Vitality",
    tile: "/images/services/tile-vitality.webp",
    tileAlt: "Woman running outdoors at sunset",
    background: "/images/services/bg-vitality.webp",
    title: "Vitality",
    intro: [
      "At about U, we are committed to your overall well-being, and that's why we're excited to introduce our innovative Vitality Program. Rooted in cutting-edge science and driven by the power of data analytics, this dynamic program is designed to empower and inspire you on your journey to better health.",
      "Our Vitality Program goes beyond traditional insurance offerings, as it actively engages with your daily life, motivating positive behavior changes that lead to healthier choices. By seamlessly integrating technology, personalized insights, and a range of enticing rewards and incentives, we provide you with the tools you need to make sustainable improvements in your lifestyle.",
      "With the Vitality Program, your path to well-being is not only supported, but also celebrated every step of the way. Your health is your greatest asset, and we're here to ensure that you're not only protected but also empowered to live life to the fullest.",
    ],
    list: [],
    images: [
      "/images/services/vitality-1.webp",
      "/images/services/vitality-2.webp",
      "/images/services/vitality-3.webp",
      "/images/services/vitality-4.webp",
    ],
  },
];

//Order of the Our Services drop-down menu, as on the Wix site
export const SERVICES_MENU = [
  "/medical-schemes-gap-cover-1",
  "/investments-retirement",
  "/short-term-insurance",
  "/risk-cover",
  "/banking",
  "/vitality",
].map((path) => SERVICES.find((s) => s.path === path));

export const NAV_LINKS = [
  { label: "Home", path: ROUTES.HOME },
  { label: "Our Services", path: ROUTES.SERVICES, children: SERVICES_MENU },
  { label: "about U Team", path: ROUTES.TEAM },
  { label: "Company Statement", path: ROUTES.COMPANY_STATEMENT },
  { label: "Client Testimonials", path: ROUTES.TESTIMONIALS },
  { label: "Blog", path: ROUTES.BLOG },
  { label: "Contact Us", path: ROUTES.CONTACT },
];

/* ------------------------------ HOME ------------------------------ */

export const HOME = {
  HEADING: "Discovery Financial Advisors",
  SUBHEADING: "in George, Western Cape",
  ABOUT_HEADING: "ABOUT US",
  ABOUT: "about U is a mandated juristic representative of Discovery Life, an authorised Financial Services Provider, FSP License number 18147 anchored in George in the Southern Cape, but our Specialist Advisors work Nationally.  Thousands of happy clients have already reaped the benefits of our different approach of “helping rather than selling” offered by our team of specialist financial professionals. We can structure a solution customised around your financial needs, whether it’s providing you with selecting the best health cover, life cover & retirement planning based on your own estate planning, or your short-term needs, banking services as well as substantial investment options. Make an informed choice when selecting your advisor.  No two clients or their needs are the same.  So, before we do anything we sit down and listen and only then do we apply our knowledge.",
  TEAM_HEADING: "Meet the about U Team",
};

/* ------------------------------ TEAM ------------------------------ */

export const TEAM_TAGLINE = "Dedication. Expertise. Passion.";

//Order is as on the about U Team page
export const TEAM = [
  {
    name: "Carina Strydom",
    role: "Principal",
    email: "carina@aboutu.co.za",
    photo: "/images/team/carina-strydom.webp",
    bio: ["Carina is a people person and thoroughly believes that all aspects of financial planning should make the lives of people easier, not more difficult.  She uses her 38 years of experience in the financial services sector to lead and inspire the AboutU team to achieve even higher levels of service excellence and people-driven solutions."],
  },
  {
    name: "Chrissie Bothma",
    role: "Office Manager",
    email: "info@aboutu.co.za",
    photo: "/images/team/chrissie-bothma.webp",
    bio: ["Chrismaré has been with the company since 2006 and her main responsibility is the smooth sailing and efficient front and back office operations. From answering the phones, directing clients to correct specialists, internal procedures and maintenance.  She is known as an all-rounder."],
  },
  {
    name: "Xolani Xakaza",
    role: "Senior Sales Consultant",
    email: "xolani@aboutu.co.za",
    photo: "/images/team/xolani-xakaza.webp",
    bio: ["Xolani is a Senior Insurance Sales Consultant at AboutU Financial Advisors, specializing in Discovery Insure . He joined AboutU in 2020 and brings over a decade of experience in the financial industry. Xolani holds qualifications in wealth management, highlighting his expertise in providing comprehensive financial solutions. He understands that insurance is about offering clients peace of mind and ensuring they receive prompt and effective support during unforeseen events. Xolani’s commitment to attentive client listening and delivering personalized advice enables him to craft strategies that perfectly align with each client’s unique needs."],
  },
  {
    name: "Michelle Barnard",
    role: "Financial Adviser",
    email: "michelle@aboutu.co.za",
    photo: "/images/team/michelle-barnard.webp",
    bio: ["Michelle has been in the financial industry for over 19 years and began working in the medical scheme industry in 2004.  She has acquired valuable knowledge over the years and firmly believes that exceptional service and extensive expertise are key to properly advising clients.  She is driven by strong ethics and a passion to provide a personalized experience for every client."],
  },
  {
    name: "Nantes (Jacobus) Du Plessis",
    role: "Financial Adviser Bank & Insure",
    homeRole: "Bank Financial Adviser & Insure Servicing Consultant", //As shown in the home page team row on the Wix site
    email: "jacobus@aboutu.co.za",
    photo: "/images/team/nantes-du-plessis.webp",
    bio: ["Nantes is a dedicated professional with 5 years of experience in the Financial industry. He strives to meet our clients’ needs, whether over the phone or face to face. Serving other is his purpose in life. He firmly believes that building long lasting relationships is of utmost importance. He focuses on Discovery Bank, Servicing client needs on Discovery Insure and helping clients make the most of Vitality Drive."],
  },
  {
    name: "Anlé Rossouw",
    role: "Health Claims Consultant",
    email: "admin2@aboutu.co.za",
    photo: "/images/team/anle-rossouw.webp",
    bio: ["Anle brings a wealth of 20 years of experience to the Medical Scheme industry. She specializes in Medical Claims, Chronic Benefits/Queries, Oncology Benefits/Queries, and Prescribed Minimum Benefit/Queries. In addition to her expertise, she also plays a key role in handling Authorization requests and approvals, and she excels in providing top-notch client services. Anle has been a valuable part of our company for the past 8 years, consistently dedicated to meeting our clients' needs, whether through phone consultations or face-to-face interactions. Her passion for her work drives her to always go the extra mile for our clients, ensuring their utmost satisfaction."],
  },
  {
    name: "Melissa van der Westhuizen",
    role: "Servicing Consultant",
    email: "admin1@aboutu.co.za",
    photo: "/images/team/melissa-van-der-westhuizen.webp",
    bio: ["Melissa boasts an impressive 10-year background in the Financial services industry, starting in short-term insurance and gaining valuable insights through roles as a Sales Specialist and later a Claims Specialist. In 2023, she expanded her expertise to the long-term and health sectors, demonstrating her commitment to professional growth. Melissa's defining traits include a mature and responsible approach to work, taking ownership of responsibilities, fearlessly tackling challenges, and consistently delivering results that surpass expectations, all while maintaining composure under pressure for smooth project and task execution."],
  },
  {
    name: "Kaylan van Wyk",
    role: "Insure Consultant",
    email: "consultant5@aboutu.co.za",
    photo: "/images/team/kaylan-van-wyk.webp",
    bio: ["Kaylan, a junior sales consultant, has been in the industry since 2023, specializing in Discovery Insure products, with a deep passion for delivering exceptional service. She takes pride in offering personalized solutions tailored to each client's needs, ensuring a seamless and positive experience. She is driven by a commitment to excellence, consistently going above and beyond to provide fantastic service. Her approachable, professional style allows her to connect with clients, building trust and lasting relationships. Her motto “you not fully dressed without a smile”"],
  },
  {
    name: "Kristin Jacobs",
    //Not shown on the Wix team page - taken from the home page team carousel
    role: "Insure Servicing Consultant",
    email: "consultant4@aboutu.co.za",
    photo: "/images/team/kristin-jacobs.webp",
    bio: ["Kris has two years of dedicated experience in the insurance industry, during which she has developed a well-rounded understanding of key areas within the field. Her journey has provided her with valuable insights into the legal, sales, and claims departments, each contributing to her broad perspective and expertise. Passionate about her work, Kris is currently focused on advancing her qualifications and is actively pursuing her RE certification. Her commitment to the industry drives her to continuously enhance her skills and make meaningful contributions. Currently, working in the claims department, Kris thrives on helping clients by delivering the service they need and ensuring they feel safe and supported during vulnerable times."],
  },
  {
    name: "Corriné Jonkers",
    role: "Assistant Financial Advisor",
    email: "corrine@aboutu.co.za",
    photo: "/images/team/corrine-jonkers.webp",
    bio: ["Corriné is a dedicated professional in the financial services industry with 9 years of experience. Known for a positive attitude and a commitment to excellence, Corriné  is always ready to serve clients with a smile. As a young professional, she brings fresh energy and perspective to every partnership, while maintaining a reputation for exceptional attention to detail. This combination of enthusiasm and precision makes her the perfect fit for delivering outstanding service and building lasting client relationships. Corriné is proud to contribute to the mission of AboutU."],
  },
  {
    name: "Lizzy Blou",
    role: "General Assistant",
    email: null,
    photo: "/images/team/lizzy-blou.webp",
    bio: ["Lizzy Blou is a dedicated general assistant at AboutU. With her keen organisational skills and unwavering commitment, Lizzy plays a pivotal role in supporting the company's mission to provide top-notch financial guidance to its clients."],
  },
  {
    name: "Denise Human",
    role: "Personal Assistant to Michelle Barnard",
    email: "admin7@aboutu.co.za",
    photo: "/images/team/denise-human.webp",
    bio: [
      "Denise comes with 44 years of experience in the Medical Sectors with a Financial Background. Starting off at Hospitals and later Private Practices and Health Care Specialist companies.",
      "She specializes providing support to the Financial Advisors in the medical aid field for both new and existing clients. She is committed to delivering a high standard of client care.  With a calm, approachable manner, she manages situations and client concerns with discretion and professionalism, aligning with the company’s service standards, in this sensitive area of medical financial care.",
    ],
  },
];

//Order of the home page team row (as on the Wix site - it differs from the team page)
export const HOME_TEAM = [
  "Carina Strydom",
  "Chrissie Bothma",
  "Michelle Barnard",
  "Nantes (Jacobus) Du Plessis",
  "Anlé Rossouw",
  "Melissa van der Westhuizen",
  "Xolani Xakaza",
  "Kaylan van Wyk",
  "Kristin Jacobs",
  "Corriné Jonkers",
  "Denise Human",
  "Lizzy Blou",
].map((name) => TEAM.find((member) => member.name === name));

/* ------------------------------ COMPANY STATEMENT ------------------------------ */

export const COMPANY_STATEMENT = {
  INTRO: "A company with a difference that believe and live Discovery’s core purpose to make people healthier and enhance and protect their lives.",
  PROMISE: "Remember the AboutU Promise : When you become an AboutU client, you gain a dedicated team committed to supporting every aspect of your financial wellbeing.",
  PILLARS: ["Dedicated Advice", "Personal Service", "Lifelong partnerships"],
  BLOCKS: [
    {
      icon: "approach",
      title: "Our Approach",
      text: [
        "\"Listen deeply and always act with empathy.\" - Richard Branson",
        "One size rarely fits all, so it’s important to listen to the needs of each individual and find solutions that allow everyone to work at their best.",
      ],
      isDark: true,
    },
    {
      icon: "vision",
      title: "Our Vision",
      text: ["We consider our clients as our business partners and our success is measured by their endorsement."],
      isDark: false,
    },
    {
      icon: "mission",
      title: "Our Mission",
      text: ["To be a small but effective and successful team who apply our knowledge to deliver focused advice through innovation."],
      isDark: true,
    },
    {
      icon: "philosophy",
      title: "Our Philosophy",
      text: ["We believe in helping people.  If we don’t take care of our customers, our competitors will.  Therefore we treat everyone as we want to be treated and by helping people with our expertise and by caring, we can make a difference."],
      isDark: false,
    },
  ],
};

/* ------------------------------ TESTIMONIALS ------------------------------ */

//Order is as in the Wix slideshow. The Wix slideshow had G Maree's testimonial twice, so it's only included once here
export const TESTIMONIALS = [
  {
    name: "C Lombard",
    text: ["“AboutU se mediese afdeling is die beste. Jy kry nie net goeie raad nie, maar ook baie goeie advies.”"],
  },
  {
    name: "Kim Gess",
    text: ["“We have worked with AboutU for many years – managing both our personal and business assurances. They are always most efficient, informative and helpful and we highly recommend them!”"],
  },
  {
    name: "NRG Shabalala",
    text: ["\"I am happy to be part of this family(DISCOVERY ABOUTU). Since I met them , I never felt alone when having an incident. The support I get from them is beyond measure. They are available when you need them and they walk with you all the time. I value Discovery About U Advisors, and I will never turn back against them. My experience with them , I ensure that I convince my family members to try Discovery AboutU Advisors and they will always be happy like me\""],
  },
  {
    name: "J Winfield",
    text: ["“I usually find it terribly difficult to get to grips with the nuances of all the various options presented by Discovery, whether it be their Medical Aid, their Life Assurance or their Short-Term Insurance schemes. That is until I met Carina Strydom and the staff at AboutU. With their intimate understanding of the various products offered by Discovery, and having carefully assessed my personal requirements, I have always received the most sound, professional advice. Offered in all sincerity! I trust you and your staff implicitly to always do the best for me.’’"],
  },
  {
    name: "Shirley Thomlinson",
    text: ["“Never a day passed that an email wasn't answered in 24 hours or less.  Anle always ensured that I was provided with all the information and paperwork I needed to sort my folks’ medical affairs out, and went above and beyond to contact Doctors, Hospitals etc. when I wasn't having any luck. She's truly a star! ”"],
  },
  {
    name: "R Lentz",
    text: ["‘’I've been a loyal client at AboutU for years. They've seen me through very complex times, including when my son was studying in a different city, when suddenly we had two households needing cover, two cars in separate cities and various specified items between them. I've also had my fair share of really bizarre claims over the years. The team will tell you about the day I phoned from the road side in tears, because I'd hit sheep - more worried about the sheep than my car! Never once was there a hiccup or a fight. I literally log my claim via WhatsApp and the team at AboutU take care of the rest. I've had so many companies try to beat my premiums, but nobody can. And NOBODY can match the personal touch I've experienced over the years.’’"],
  },
  {
    name: "G Maree",
    text: [
      "I would like to extend my heartfelt gratitude to Carina and her exceptional team at About U Finance in George for the outstanding service they have provided. They have been managing our medical and life insurance portfolios, and the level of service we have received has been truly commendable.",
      "Carina and her team consistently demonstrate their commitment to excellence through their effective and prompt responses to our inquiries and needs. They go above and beyond to ensure that we are not only well-covered but also that we receive the best possible insurance packages at the most competitive prices.",
      "Their dedication to finding the perfect insurance solutions for their clients is truly admirable. It's reassuring to know that we have a team of professionals like Carina and her colleagues looking out for our best interests when it comes to our financial security.",
      "In an industry where trust and reliability are paramount, About U Finance in George has proven time and again that they are the go-to choice. I wholeheartedly recommend their services to anyone seeking top-notch financial and insurance solutions. Thank you, Carina and the entire team, for your exceptional service and the peace of mind you provide.",
    ],
  },
  {
    name: "D Patrick",
    text: ["I want to express my sincere gratitude to About U Financial Advisors for their exceptional service over the past six years. Carina and her team have been invaluable in ensuring the well-being of my family through various insurance policies. From the beginning, About U has consistently demonstrated professionalism and commitment that exceeded my expectations. Carina's expertise and guidance have been instrumental in helping me make informed decisions about my insurance needs. She takes the time to explain policy intricacies, ensuring I fully understand my coverage. About U's unwavering commitment to customer satisfaction is evident, with Carina and her team readily available to provide support. Their responsiveness and willingness to address concerns give me peace of mind. Over the years, About U has consistently offered competitive rates, tailoring insurance solutions to my changing circumstances. I'm grateful for their outstanding service and unwavering support, and I wholeheartedly recommend About U to those seeking reliable insurance services. Thank you for being my trusted insurance partner for the past eight years. I look forward to continued collaboration for many more years."],
  },
];
